import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, translate } from '../../utils/useful'

class TableProductSelectInput extends React.Component {


    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    getLabel(key) {

        let fields = this.props.header?.information?.viewFields ?? this.props.header?.information?.fields
        switch (key) {
            case 'title':
                if (this.props.data) {
                    if (typeof this.props.data == 'object') {

                        return getObject(this.props.data, fields?.title)
                    } else {
                        if (this.props.header?.information?.items?.length) {
                            for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                                const item = this.props.header?.information?.items[i];
                                if (item.value == this.props.data) {
                                    return item[key]
                                }
                            }
                        }
                    }
                } else {
                    if (this.props.header?.information?.default) {
                        for (let i = 0; i < this.props.header?.information?.items?.length; i++) {
                            const item = this.props.header?.information?.items[i];
                            if (item.value == this.props.header?.information?.default) {
                                return item[key]
                            }
                        }
                    } else {
                        return ' '
                    }
                }
                break;
            case 'color': {

                let color = ''
                if (!this.props.header?.information?.type || this.props.header?.information?.type == 'local') {
                    let value = typeof this.props.data == 'object' ? getObject(this.props.data, fields?.value) : this.props.data
                    this.props.header?.information?.items?.map((element) => {
                        // console.log("value",value,element.value)

                        if (value == element.value) {
                            color = element.color
                        }
                    })

                }
                return color ?? ''
            }

            case 'background': {

                let background = ''
                if (!this.props.header?.information?.type || this.props.header?.information?.type != 'local') {
                    let value = typeof this.props.data == 'object' ? getObject(this.props.data, fields?.value) : this.props.data
                    this.props.header?.information?.items?.map((element) => {
                        if (value == element.value) {
                            background = element.background
                        }
                    })

                }
                return background ?? ''
            }
            default:
                break;
        }

    }



    showVariants = (product) => {


        let repeat
        let duration

        let activeVariants = getObject(this.props.fullData, 'variants')
        let activeAdditionals = getObject(this.props.fullData, 'additionals')
        let isSubscription = product?.type == 'membership' && product?.priceType == 'subscription' && Array.isArray(product?.subscriptionPrice) == true && product?.subscriptionPrice?.length > 0


        // let isSubscription = product?.type == 'membership' && product?.priceType == 'subscription' && Array.isArray(product?.subscriptionPrice) == true && product?.subscriptionPrice?.length > 0

        if (isSubscription && activeVariants) {
            repeat = activeVariants?.repeat ?? 1
            duration = (activeVariants?.duration ?? 'year') + (repeat > 1 ? 's' : '')

            if (repeat == 1) {
                switch (duration) {
                    case 'year':
                        duration = 'Yearly'
                        break;

                    case 'month':
                        duration = 'Monthly'
                        break;

                    case 'Week':
                        duration = 'Weekly'
                        break;

                    default:
                        break;
                }
            }
        }


        return (
            <>
                {/* {product?.type != 'membership' && (
                    <button className='mb-1' >
                        <p className='font-size-16 weight-600 '>{checkTranslation(product?.name)}</p>
                    </button>
                )} */}

                {/* {product?.type == 'membership' && (
                    <div className='mb-1' >
                        <p className='font-size-16 weight-600 '>{translate("Subscribe")}: {checkTranslation(product?.name)} - {activeVariants?.repeat} {translate(activeVariants?.duration)}</p>
                    </div>
                )} */}


                {/* {product?.type == 'membership' && (
                    <p className='text-small'>USD {activeVariants?.price}</p>
                )} */}

                {/* {product?.type == 'membership' && activeVariants?.duration == 'year' && (
                    <p className='text-small'>Billed annualy</p>
                )} */}

                {isSubscription && activeVariants && (

                    <p className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}>{repeat > 1 ? `${repeat} - ` : ''}{translate(duration)}</p>

                )}


                {product?.type != 'membership' && activeVariants && (
                    <div className='w-100'>
                        {Object.entries(activeVariants)?.map(([key, value]) => {
                            return (
                                <p className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-13'>{key}:</span> {value}</p>
                            )
                        })}
                    </div>
                )}


                {typeof activeAdditionals == 'object' && (
                    <div className='w-100'>
                        {activeAdditionals && Object.entries(activeAdditionals)?.map(([key, value]) => {
                            return (
                                <div>
                                    <span className='font-size-12 weight-400 main-c7 ' style={{ textTransform: 'capitalize' }}>{key}:
                                        {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                            return (
                                                <span>
                                                    {optionKey == 'text' ? (
                                                        <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                    ) : (
                                                        <>
                                                            <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                {(optionValue?.priceDifference != null && optionValue?.priceDifference > 0) && (
                                                                    <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                        ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                    </span>
                                                                )}
                                                            </span>

                                                        </>
                                                    )}
                                                    {(oindex < (Object.entries(value).length - 1)) && (
                                                        <span className='mld-1'>,</span>
                                                    )}
                                                </span>
                                            )
                                        })}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </>
        )
    }


    render() {
        return (
            <div className="w-100 h-100 py-1">
                <div className='flexc'>
                    <p className=" " style={{ color: this.getLabel("color") ? this.getLabel("color") : '', backgroundColor: this.getLabel("background"), textOverflow: 'ellipsis', overflow: 'hidden', borderRadius: 6 }}>{checkTranslation(this.getLabel("title"))}</p>
                </div>

                {this.showVariants(this.props.data)}

            </div>
        )
    }
}

export default TableProductSelectInput;